module.exports = __webpack_public_path__ + "static/media/Candy.cfbf4fd1.jpeg";